import cn from 'classnames'
import React from 'react'
import { useSharedState } from '../waxplorer/Waxplorer'
import MarketAssetPreview from '../assetpreview/MarketAssetPreview'

export const MarketList = (props) => {
    const assets = props['assets']
    const search = props['search']
    const clickAsset = props['clickAsset']
    const selectedAsset = props['selectedAsset']
    const id = props['id']
    const selectedAssets = props['selectedAssets']
        ? props['selectedAssets']
        : []
    const page = props['page']
    const selectable = props['selectable']
    const searchOwner = props['searchOwner']
    const [state, dispatch] = useSharedState()

    const localSelectedAssets = state.selectedAssets

    const handleCheck = (e, asset) => {
        if (e.target.checked) {
            localSelectedAssets.push(asset)
            dispatch({
                type: 'SET_SELECTED_ASSETS',
                payload: localSelectedAssets,
            })
        } else {
            const realNewSelectedAssets = []
            localSelectedAssets
                .filter(
                    (a) =>
                        (a.assets ? a.assets[0] : a).assetId !==
                        (asset.assets ? asset.assets[0] : asset).assetId,
                )
                .map((item) => realNewSelectedAssets.push(item))
            dispatch({
                type: 'SET_SELECTED_ASSETS',
                payload: realNewSelectedAssets,
            })
        }
    }

    return (
        <div
            className={cn(
                {
                    'grid sm:gap-4 gap-2 grid-cols-1 xsse:grid-cols-2 sm1:grid-cols-3 md:grid-cols-3 md1:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-7 4xl:grid-cols-7 text-center sm:mx-4 mx-2':
                        search !== 'tradable',
                },

                {
                    'grid grid-cols-1 md:grid-cols-3 gap-x-5':
                        search === 'tradable',
                },
            )}
            id={id ? id : ''}
        >
            {assets &&
                assets
                    .filter(
                        (asset) =>
                            !selectedAssets ||
                            !selectedAssets.includes(
                                asset.listingId.toString(),
                            ),
                    )
                    .map((asset, index) => (
                        <MarketAssetPreview
                            index={index}
                            key={`${asset.listingId}_${index}`}
                            listing={asset}
                            selectable={selectable}
                            searchOwner={searchOwner}
                            clickAsset={clickAsset}
                            selectedAsset={selectedAsset}
                            selectedAssets={selectedAssets}
                            selectedListings={state.selectedListings}
                            errorListings={state.errorListings}
                            isSelected={
                                state.selectedListings
                                    ?.map((l) => l.listingId)
                                    .includes(asset.listingId)
                                    ? asset.listingId
                                    : null
                            }
                            handleCheck={handleCheck}
                            page={page}
                        />
                    ))}
        </div>
    )
}
